export default __webpack_public_path__ + "static/media/six.b9932ad1.jpg";